const defaultSidebarState = { visible: false };

export const NAME = 'sidebar';
export function sidebarReducer(state = defaultSidebarState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'HIDE_SIDEBAR':
    case 'SHOW_SIDEBAR':
    case 'SWAP_SIDEBAR':
      return { ...state, ...payload };
    default:
      return state;
  }
}

export default {
  constants: { NAME },
  reducers: { sidebarReducer },
};
